var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.customTableClass,
    style: (_vm.customTableStyle)
  }, [(_vm.loading) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "14px"
    }
  }, [_vm._v("\n            数据加载中\n        ")]) : _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [(_vm.checkable && _vm.option.editable) ? _c('div', {
    staticStyle: {
      "width": "60px"
    }
  }, [_c('checkbox', {
    attrs: {
      "value": _vm.allitemChecked
    },
    on: {
      "on-change": _vm.checkAllChanged
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.option.editable) ? _c('div', {
    staticStyle: {
      "width": "60px"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(c, index) {
    return (!c.hide) ? _c('div', {
      key: index,
      staticClass: "flex",
      style: ('width: ' + c.width + 'px;color: #aaa;padding-right: 10px;')
    }, [_c('div', [_c('div', [_vm._v(_vm._s(c.title))]), _vm._v(" "), (c.label) ? _c('div', {
      staticStyle: {
        "line-height": "1",
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(c.label))]) : _vm._e()]), _vm._v(" "), (c.tip) ? _c('PageTooltip', {
      attrs: {
        "content": c.tip,
        "width": 300,
        "name": '',
        "placement": 'top-start'
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.checkable && _vm.option.editable && _vm.newItems.filter(function (o) {
    return o._checked
  })[0]) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "margin-top": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }), _vm._v(" "), (_vm.option.editable && _vm.quickedit) ? _c('div', {
    staticStyle: {
      "width": "60px",
      "margin-top": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "align-items": "center"
    }
  }, _vm._l((_vm.columns), function(c, i) {
    return _c('div', {
      key: i,
      style: ('width: ' + _vm.columns[i].width + 'px;padding-right:10px;')
    }, [(!c.batchset) ? _c('div', [_vm._v("--")]) : _c('div', [(c.type == 'xieyi') ? _c('div', [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.columns[i].onclick(-1, _vm.batchitem)
        }
      }
    }, [_vm._v("批量选择协议")])], 1) : _vm._e(), _vm._v(" "), (c.type == 'button') ? _c('div', [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.columns[i].onclick(-1, _vm.batchitem)
        }
      }
    }, [_vm._v("批量设置")])], 1) : _vm._e(), _vm._v(" "), (c.type == 'wupin') ? _c('div') : (c.type == 'selection') ? _c('div', [(c.editable) ? _c('div', [(c.version == 2 || c.batchset) ? _c('Select', {
      style: ('width: ' + (c.width - 10) + 'px;'),
      attrs: {
        "placeholder": "批量设置",
        "value": _vm.batchitem[c.keyStr || (c.key + 'Str')]
      },
      on: {
        "on-change": function($event) {
          return _vm.dataChanged(_vm.batchitem, c, $event, 'batch')
        }
      }
    }, _vm._l((c.selections(_vm.batchitem)), function(s, si) {
      return _c('Option', {
        key: si,
        attrs: {
          "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
        }
      }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(_vm.batchitem, s) : s[c.selectionKey]) + "\n                                        ")])
    }), 1) : _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.batchitem[c.keyStr || (c.key + 'Str')]),
        expression: "batchitem[c.keyStr || (c.key+'Str')]"
      }],
      staticClass: "wupin-select",
      style: ('width: ' + (c.width - 20) + 'px;'),
      attrs: {
        "placeholder": "批量设置"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.batchitem, c.keyStr || (c.key + 'Str'), $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.dataChanged(_vm.batchitem, c, _vm.batchitem[c.keyStr || (c.key + 'Str')], 'batch')
        }]
      }
    }, _vm._l((c.selections(_vm.batchitem)), function(s, si) {
      return _c('option', {
        key: si,
        staticClass: "wupin-option",
        domProps: {
          "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
        }
      }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(_vm.batchitem, s) : s[c.selectionKey]))])
    }), 0)], 1) : _c('div', [_vm._v(_vm._s(_vm.batchitem[c.keyStr || (c.key + 'Str')]))])]) : (c.type == 'danjia') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": c.fixAppend ? c.fixAppend(_vm.batchitem) : 6,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), c.fixAppend ? c.fixAppend(_vm.batchitem) : 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], c.fixAppend ? c.fixAppend(_vm.batchitem) : 6)))])], 1)]) : (c.type == 'jine') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": 2,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), 2)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], 2)))])], 1)]) : (c.type == 'shuilv') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": 4,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), 4)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], 4)))])], 1)]) : (c.type == 'shuliang') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
      attrs: {
        "value": _vm.batchitem[c.key],
        "fix": 6,
        "min": c.min,
        "max": c.max,
        "placeholder": "批量设置",
        "width": _vm.columns[i].width - 10,
        "unit": c.append ? c.append(_vm.batchitem) : ''
      },
      on: {
        "input": function($event) {
          return _vm.getInput($event, _vm.batchitem, c, 'batch')
        }
      }
    }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(_vm.batchitem), 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(_vm.batchitem[c.key], 6)))])], 1)]) : (c.type === 'text' || c.type === 'beizhu') ? _c('div', [(c.editable) ? _c('div', [_c('Input', {
      attrs: {
        "placeholder": "批量设置"
      },
      model: {
        value: (_vm.batchitem[c.key]),
        callback: function($$v) {
          _vm.$set(_vm.batchitem, c.key, $$v)
        },
        expression: "batchitem[c.key]"
      }
    })], 1) : _c('div', [_vm._v(_vm._s(_vm.batchitem[c.key]))])]) : _c('div', [_c('div', [_vm._v(_vm._s((_vm.batchitem[c.key] && c.subKey) ? _vm.batchitem[c.key][c.subKey] : _vm.batchitem[c.key]))])])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.newItems), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [(_vm.checkable && _vm.option.editable) ? _c('div', {
      staticStyle: {
        "width": "60px",
        "margin-top": "10px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('checkbox', {
      on: {
        "on-change": _vm.checkChanged
      },
      model: {
        value: (item._checked),
        callback: function($$v) {
          _vm.$set(item, "_checked", $$v)
        },
        expression: "item._checked"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.option.editable && _vm.quickedit) ? _c('div', {
      staticStyle: {
        "width": "60px",
        "margin-top": "10px",
        "display": "flex",
        "align-items": "center"
      }
    }, [(item._readonly) ? _c('div', [_c('Icon', {
      attrs: {
        "type": "md-add",
        "size": "20",
        "color": "#ccc"
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "md-remove",
        "size": "20",
        "color": "#ccc"
      }
    })], 1) : _c('div', [_c('Icon', {
      staticClass: "hover",
      attrs: {
        "type": "md-add",
        "size": "20",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(item, index)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      staticClass: "hover",
      attrs: {
        "type": "md-remove",
        "size": "20",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(item, index)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (item.disabled) ? _c('div', [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "word-wrap": "break-word"
      },
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "#aaa",
        "line-height": "1"
      }
    }, [_vm._v(_vm._s(item.code) + " ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "line-height": "1",
        "font-size": "11px",
        "color": "#aaa"
      }
    }, [(item.guigexinghao) ? _c('div', [_vm._v(_vm._s(item.guigexinghao))]) : _vm._e(), _vm._v(" "), (item.wupinpinpai) ? _c('div', [_vm._v(_vm._s(item.wupinpinpai))]) : _vm._e()]), _vm._v(" "), (item.actived === false) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "red",
        "line-height": "1",
        "margin-top": "8px"
      }
    }, [_vm._v("已停用")]) : _vm._e(), _vm._v(" "), (item.weixiafa) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "red",
        "line-height": "1",
        "margin-top": "8px"
      }
    }, [_vm._v("未下发")]) : _vm._e(), _vm._v(" "), (item.error) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "color": "red",
        "line-height": "1",
        "margin-top": "8px"
      }
    }, [_vm._v(_vm._s(item.error))]) : _vm._e(), _vm._v(" "), _vm._t("disableText")], 2) : _c('div', {
      staticStyle: {
        "display": "flex",
        "margin-top": "10px",
        "align-items": "center"
      }
    }, _vm._l((_vm.columns), function(c, i) {
      return _c('div', {
        key: i,
        style: ('width: ' + _vm.columns[i].width + 'px;padding-right:10px;')
      }, [(c.vif && !c.vif(item)) ? _c('div', [_vm._v("--")]) : _c('div', [(c.type == 'xieyi') ? _c('div', {
        style: (item.error ? 'color:red' : ''),
        attrs: {
          "title": item.name
        }
      }, [(item.xieyi) ? _c('div', [_vm._v("\n                                    " + _vm._s(item.xieyi.name) + "\n                                    "), _c('div', {
        style: (((item.error?'color:red;':'color: #aaa;') + "font-size: 11px;line-height: 1;"))
      }, [_vm._v(_vm._s(item.xieyi.code) + " ")])]) : _c('div', [_c('Button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.columns[i].onclick(index, item)
          }
        }
      }, [_vm._v("选择协议")])], 1)]) : _vm._e(), _vm._v(" "), (c.type == 'button') ? _c('div', {
        style: (item.error ? 'color:red' : '')
      }, [(c.editable) ? _c('div', [(item[c.key] && c.html) ? _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.columns[i].onclick(index, item)
          }
        }
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(c.html(item, index))
        }
      })])]) : _c('div', [_c('Button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.columns[i].onclick(index, item)
          }
        }
      }, [_vm._v(_vm._s(c.name))])], 1)]) : _c('div', [(item[c.key] && c.html) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(c.html(item, index))
        }
      })]) : _c('div', [_vm._v("-")])])]) : (c.type == 'wupin') ? _c('div', {
        style: (item.error ? 'color:red' : ''),
        attrs: {
          "title": item.name
        }
      }, [_c('div', {
        staticStyle: {
          "font-weight": "bold",
          "word-wrap": "break-word"
        },
        attrs: {
          "title": item.name
        }
      }, [_vm._v(_vm._s(item.name) + " ")]), _vm._v(" "), _c('div', {
        style: (((item.error?'color:red;':'color: #aaa;') + "font-size: 11px;line-height: 1;"))
      }, [_vm._v(_vm._s(item.code) + " ")]), _vm._v(" "), _c('div', {
        style: (((item.error?'color:red;':'color: #aaa;') + "display: flex;line-height: 1;font-size: 11px;"))
      }, [(item.guigexinghao) ? _c('div', [_vm._v(_vm._s(item.guigexinghao))]) : _vm._e(), _vm._v(" "), (item.wupinpinpai) ? _c('div', [_vm._v(_vm._s(item.wupinpinpai))]) : _vm._e()]), _vm._v(" "), (item.actived === false) ? _c('div', {
        staticStyle: {
          "font-size": "11px",
          "color": "red",
          "line-height": "1",
          "margin-top": "8px"
        }
      }, [_vm._v("已停用")]) : _vm._e(), _vm._v(" "), (item.weixiafa) ? _c('div', {
        staticStyle: {
          "font-size": "11px",
          "color": "red",
          "line-height": "1",
          "margin-top": "8px"
        }
      }, [_vm._v("未下发")]) : _vm._e(), _vm._v(" "), (item.error) ? _c('div', {
        staticStyle: {
          "font-size": "11px",
          "color": "red",
          "line-height": "1",
          "margin-top": "8px"
        }
      }, [_vm._v(_vm._s(item.error))]) : _vm._e()]) : (c.type == 'selection') ? _c('div', [(c.editable) ? _c('div', [(c.version == 2 || c.batchset) ? _c('Select', {
        style: ('width: ' + (c.width - 10) + 'px;'),
        attrs: {
          "value": item[c.keyStr || (c.key + 'Str')],
          "name": item[c.keyStr || (c.key + 'Str')] + index
        },
        on: {
          "on-change": function($event) {
            return _vm.dataChanged(item, c, $event, index)
          }
        }
      }, _vm._l((c.selections(item)), function(s, si) {
        return _c('Option', {
          key: si,
          attrs: {
            "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
          }
        }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(item, s) : s[c.selectionKey]) + "\n                                        ")])
      }), 1) : _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item[c.keyStr || (c.key + 'Str')]),
          expression: "item[c.keyStr || (c.key+'Str')]"
        }],
        staticClass: "wupin-select",
        style: ('width: ' + (c.width - 20) + 'px;'),
        attrs: {
          "name": item[c.keyStr || (c.key + 'Str')] + index
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(item, c.keyStr || (c.key + 'Str'), $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            _vm.dataChanged(item, c, item[c.keyStr || (c.key + 'Str')], index)
          }]
        }
      }, _vm._l((c.selections(item)), function(s, si) {
        return _c('option', {
          key: si,
          staticClass: "wupin-option",
          domProps: {
            "value": c.selectionvalue ? c.selectionvalue(s) : s[c.selectionKey]
          }
        }, [_vm._v("\n                                            " + _vm._s(c.selectionrender ? c.selectionrender(item, s) : s[c.selectionKey]))])
      }), 0)], 1) : _c('div', [_vm._v(_vm._s(item[c.keyStr || (c.key + 'Str')]))])]) : (c.type == 'danjia') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": c.fixAppend ? c.fixAppend(item) : 6,
          "min": c.min,
          "max": c.max,
          "required": c.required,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), c.fixAppend ? c.fixAppend(item) : 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], c.fixAppend ? c.fixAppend(item) : 6)))])], 1)]) : (c.type == 'jine') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": 2,
          "min": c.min,
          "max": c.max,
          "required": c.required,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), 2)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], 2)))])], 1)]) : (c.type == 'shuilv') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": 4,
          "min": c.min,
          "max": c.max,
          "required": c.required,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), 4)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], 4)))])], 1)]) : (c.type == 'shuliang') ? _c('div', [(c.permission && !_vm.session.permission[c.permission]) ? _c('div', [_vm._v("--")]) : _c('div', [(c.editable) ? _c('custom-input', {
        attrs: {
          "value": item[c.key],
          "fix": 6,
          "min": c.min,
          "max": c.max,
          "width": _vm.columns[i].width - 10,
          "unit": c.append ? c.append(item) : ''
        },
        on: {
          "input": function($event) {
            return _vm.getInput($event, item, c, index)
          }
        }
      }) : (c.calculate) ? _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(c.calculate(item), 6)))]) : _c('div', [_vm._v(_vm._s(_vm._f("AmountDecimal")(item[c.key], 6)))])], 1)]) : (c.type === 'beizhu') ? _c('div', [(c.editable) ? _c('div', [_c('Input', {
        attrs: {
          "placeholder": "请输入"
        },
        model: {
          value: (item[c.key]),
          callback: function($$v) {
            _vm.$set(item, c.key, $$v)
          },
          expression: "item[c.key]"
        }
      })], 1) : _c('div', [_vm._v(_vm._s(item[c.key]))])]) : _c('div', [(c.html) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(c.html(item, index))
        }
      })]) : _c('div', [_vm._v(_vm._s((item[c.key] && c.subKey) ? item[c.key][c.subKey] : item[c.key]))])])])])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), ((!_vm.newItems.length || _vm.option.alwaysShowAddButton) && _vm.editable) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "position": "absolute",
      "left": "calc(50% - 50px)",
      "height": "40px"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(_vm._s(_vm.option.buttonLabel || '新增') + "\n                        "), _c('Icon', {
    attrs: {
      "type": "ios-add"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  })]) : _vm._e()], 2)]), _vm._v(" "), (!_vm.editable && !_vm.onepagemode && (_vm.total > _vm.page.size || _vm.page.size > 10)) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Page', {
    attrs: {
      "placement": "top",
      "page-size-opts": [10, 20, 50, 100, 200],
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-total": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  })], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-453801a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CustomTable.vue
// module id = cSsU
// module chunks = 138